export default function NoticeBubble({ message, top = '-top-5', left = 'left-4', rotate = '-rotate-12' }: { message: string, top?: string, left?: string, rotate?: string }) {
    return (
        <div className={`absolute px-4 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl shadow-lg z-10 border border-blue-400/30 transform ${rotate} ${top} ${left} backdrop-blur-sm`}>
            <div className="text-center">
                <p className="font-semibold text-sm text-white m-0!" style={{  margin: 0 }}>{message}</p>
            </div>
            {/* Subtle arrow pointing down */}
            <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2">
                <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-blue-500"></div>
            </div>
        </div>
    );
}